import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class HelpersService {
  apiLoaded: Observable<boolean>
  constructor(private httpClient: HttpClient) {}

  isScriptLoaded(url: string): boolean {
    // const isFound = false
    const scripts = document.getElementsByTagName('script')
    for (let i = 0; i < scripts.length; ++i) {
      if (scripts[i].getAttribute('src') != null && scripts[i].getAttribute('src')!.includes(url)) {
        return true
      }
    }
    return false
  }

  public loadScript(url: string) {
    let isFound = false
    const scripts = document.getElementsByTagName('script')
    for (let i = 0; i < scripts.length; ++i) {
      if (scripts[i].getAttribute('src') != null && scripts[i].getAttribute('src')!.includes(url)) {
        isFound = true
      }
    }

    if (!isFound) {
      const dynamicScripts = [url]

      for (let i = 0; i < dynamicScripts.length; i++) {
        const node = document.createElement('script')
        node.src = dynamicScripts[i]
        node.type = 'text/javascript'
        node.async = false
        node.charset = 'utf-8'
        document.getElementsByTagName('head')[0].appendChild(node)
      }
    }
  }

  // googleApiLoaded() {
  //   console.log('googleApiLoaded')
  //   this.apiLoaded = this.httpClient.jsonp('https://maps.googleapis.com/maps/api/js?key=AIzaSyD8SME59ii_Jbw_YCt7M6Z4cPme9MuIHP4', 'callback').pipe(
  //     map(() => {
  //       console.log('apiLoaded true')
  //       return true
  //     }),
  //     catchError((err: any) => {
  //       console.log('apiLoaded false', err)
  //       return of(false)
  //     })
  //   )
  // }
}
